if (!customElements.get('faq-page')) {
  customElements.define('faq-page', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.items = [...this.querySelectorAll('.faq-item')];
      this.tabs = [...this.querySelectorAll('.faq-tab')];
      this.search = this.querySelector('[data-faq-search]');
      this.clear = this.querySelector('[data-faq-clear]');
      this.status = this.querySelector('[data-faq-status]');
      this.empty = this.querySelector('[data-faq-empty]');
      this.expand = this.querySelector('[data-faq-expand]');
      this.title = this.querySelector('[data-faq-section-title]');
      this.activeCategory = 'all';
      this.allExpanded = false;
      this.items.forEach(item => item.querySelector('h3 button')?.addEventListener('click', () => this.setOpen(item, !item.classList.contains('open'))));
      this.tabs.forEach(tab => tab.addEventListener('click', () => this.selectTab(tab)));
      this.search?.addEventListener('input', () => this.filter());
      this.querySelector('[data-faq-search-form]')?.addEventListener('submit', event => event.preventDefault());
      this.clear?.addEventListener('click', () => { this.search.value = ''; this.search.focus(); this.filter(); });
      this.expand?.addEventListener('click', () => this.toggleAll());
      this.updateCounts();
      this.filter();
    }
    setOpen(item, open) {
      const button = item.querySelector('h3 button');
      const answer = item.querySelector('.faq-answer');
      item.classList.toggle('open', open);
      button?.setAttribute('aria-expanded', String(open));
      if (answer) answer.hidden = !open;
    }
    updateCounts() {
      this.querySelector('[data-faq-count="all"]')?.replaceChildren(String(this.items.length));
      this.tabs.filter(tab => tab.dataset.category !== 'all').forEach(tab => {
        const key = tab.dataset.category;
        this.querySelector(`[data-faq-count="${CSS.escape(key)}"]`)?.replaceChildren(String(this.items.filter(item => item.dataset.category === key).length));
      });
    }
    selectTab(tab) {
      this.activeCategory = tab.dataset.category;
      this.tabs.forEach(candidate => { const active = candidate === tab; candidate.classList.toggle('active', active); candidate.setAttribute('aria-pressed', String(active)); });
      if (this.title) this.title.textContent = tab.dataset.title || tab.textContent.trim();
      this.filter();
      if (window.innerWidth < 1100) this.querySelector('.faq-content')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    filter() {
      const query = this.search?.value.trim().toLowerCase() || '';
      let visible = 0;
      this.items.forEach(item => {
        const categoryMatch = this.activeCategory === 'all' || item.dataset.category === this.activeCategory;
        const searchable = `${item.textContent} ${item.dataset.search || ''}`.toLowerCase();
        item.hidden = !(categoryMatch && (!query || searchable.includes(query)));
        if (!item.hidden) visible += 1; else this.setOpen(item, false);
      });
      if (this.clear) this.clear.hidden = !query;
      if (this.empty) this.empty.hidden = visible !== 0;
      if (this.expand) { this.expand.hidden = visible === 0; this.allExpanded = false; this.expand.textContent = this.expand.dataset.expand; }
      if (this.status) this.status.textContent = query ? `${visible} matching ${visible === 1 ? 'answer' : 'answers'} found.` : `Showing ${visible} ${visible === 1 ? 'question' : 'questions'}.`;
    }
    toggleAll() {
      this.allExpanded = !this.allExpanded;
      this.items.filter(item => !item.hidden).forEach(item => this.setOpen(item, this.allExpanded));
      this.expand.textContent = this.allExpanded ? this.expand.dataset.collapse : this.expand.dataset.expand;
    }
  });
}
